module.exports = __webpack_public_path__ + "static/img/desk-background.b113d78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/desk-background.jpg
// module id = Oiyl
// module chunks = 1